import { ShoppingBag } from "lucide-react";
import { useEffect, useState } from "react";
import { useCart } from "../../contexts/CartContext";

function formatPrice(price) {
  return new Intl.NumberFormat("fr-FR").format(price) + " FCFA";
}

export default function CartButton({ variant = "navbar" }) {
  const { totalItems, totalPrice, setIsOpen, bumpKey } = useCart();
  const [bumping, setBumping] = useState(false);

  // Trigger bump animation on add
  useEffect(() => {
    if (bumpKey === 0) return;
    setBumping(true);
    const t = setTimeout(() => setBumping(false), 500);
    return () => clearTimeout(t);
  }, [bumpKey]);

  if (variant === "floating") {
    return (
      <button
        onClick={() => setIsOpen(true)}
        data-testid="cart-button-floating"
        aria-label={`Ouvrir le panier (${totalItems} articles)`}
        className={`fixed bottom-24 right-6 z-40 md:hidden flex items-center justify-center w-14 h-14 rounded-full bg-[#6C3FC5] hover:bg-[#582FB0] text-white shadow-2xl shadow-[#6C3FC5]/40 transition-transform ${
          bumping ? "scale-110" : "scale-100"
        }`}
      >
        <ShoppingBag size={22} />
        {totalItems > 0 && (
          <span
            data-testid="cart-badge-floating"
            className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold w-6 h-6 rounded-full flex items-center justify-center border-2 border-[#F5F0E8]"
          >
            {totalItems > 99 ? "99+" : totalItems}
          </span>
        )}
      </button>
    );
  }

  return (
    <button
      onClick={() => setIsOpen(true)}
      data-testid="cart-button-navbar"
      aria-label={`Ouvrir le panier (${totalItems} articles)`}
      className={`relative inline-flex items-center gap-2 bg-[#6C3FC5] hover:bg-[#582FB0] text-white px-5 sm:px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 hover:scale-105 shadow-lg shadow-[#6C3FC5]/20 ${
        bumping ? "animate-cart-bump" : ""
      }`}
    >
      <ShoppingBag size={16} />
      <span className="hidden sm:inline">Panier</span>
      {totalPrice > 0 && (
        <span className="hidden md:inline text-xs opacity-90 ml-1">
          · {formatPrice(totalPrice)}
        </span>
      )}
      {totalItems > 0 && (
        <span
          data-testid="cart-badge"
          className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center border-2 border-[#F5F0E8]"
        >
          {totalItems > 99 ? "99+" : totalItems}
        </span>
      )}
    </button>
  );
}
